import { render, staticRenderFns } from "./registro-voluntariado.vue?vue&type=template&id=06306523"
import script from "./registro-voluntariado.vue?vue&type=script&lang=js"
export * from "./registro-voluntariado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports